import React from 'react';
import { Button, Divider } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

import { F } from '@/utils/intl';
import styles from './index.module.less';

/** "Manage skills" row under a skills dropdown; aligned like the options above it. */
const ManageSkillsFooter: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <>
    <Divider className={styles.selectDivider} />
    <Button type="text" icon={<SettingOutlined />} onClick={onClick} block className={styles.manageSkillsLink}>
      <F id="pages.users.manageSkills" defaultMessage="Manage skills" />
    </Button>
  </>
);

export default React.memo(ManageSkillsFooter);
